module.exports = {
  ConfigData : {
  "APP_ID": "dual-broker-reg",  
  "API_URL": "https://api.dualdev.co.uk/broker-registration/emails",
  "OCP_APIM_SUBSCRIPTION_KEY": "ae2c324b85ed49b1b0697031077cf840"
  }
}